// extracted by mini-css-extract-plugin
module.exports = {"page":"Page-module--page--2xMPY","navigation":"Page-module--navigation--1S0xd","first":"Page-module--first--4fKpj"};